import {createSlice} from "@reduxjs/toolkit";
import {DataGridPageState, DEFAULT_DISPATCH_FILTER, DispatchFilterFormValues, DispatchSeparatorMode} from "@ots-frontend/ots-ui";
import {
  setDispatchPageFilter,
  setDispatchPageState,
  setDispatchPageStateSeparatorMode,
  setDispatchPageStateSort,
  setDispatchPageStateView
} from "./actions";
import {setDispatchPageStateCell, setDispatchPageStateWidths} from "../dispatch-page/actions";

export const DISPATCH_PAGE_WIDTHS_KEY = "dispatchPageWidths6"

const savedColWidths = localStorage.getItem(DISPATCH_PAGE_WIDTHS_KEY)

export type DispatchDataGridView = "LIST" | "BLOCK"

export type DispatchDataGridPageState = DataGridPageState & {
  view: DispatchDataGridView
  separatorMode: DispatchSeparatorMode
}

type State = {
  filter: DispatchFilterFormValues
  state: DispatchDataGridPageState
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_DISPATCH_FILTER,
  state: {
    cell: undefined,
    widths: savedColWidths ? JSON.parse(savedColWidths) : [],
    view: "LIST",
    separatorMode: "DRIVER",
  }
};

const dispatchPageSlice = createSlice({
  name: "ui/dispatch-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setDispatchPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setDispatchPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      setDispatchPageStateCell,
      (state, {payload}) => {
        state.state.cell = payload
      }
    );
    builder.addCase(
      setDispatchPageStateWidths,
      (state, {payload}) => {
        state.state.widths = payload
      }
    );
    builder.addCase(
      setDispatchPageStateSort,
      (state, {payload}) => {
        state.state.sort = payload
      }
    );
    builder.addCase(
      setDispatchPageStateView,
      (state, {payload}) => {
        state.state.view = payload
      }
    );
    builder.addCase(
      setDispatchPageStateSeparatorMode,
      (state, {payload}) => {
        state.state.separatorMode = payload
      }
    );
  }
});

export const dispatchPageReducer = dispatchPageSlice.reducer;
